import { PaginationRequest } from '@monorepo/types';
import { getEnv } from '@hub/helpers/getters.store';

export class PositionStore {
  async getClosedPositions(
    tsAccountId: string,
    paginationRequest: PaginationRequest,
  ) {
    try {
      const {
        apiFactory: { positionService },
      } = getEnv();

      return positionService.getClosedPositions(tsAccountId, paginationRequest);
    } catch (e) {
      console.error(`Failed getting closed positions`, e);

      return {
        results: [],
        total: 0,
      };
    }
  }

  async getOpenPositions(
    tsAccountId: string,
    paginateRequest?: PaginationRequest,
  ) {
    try {
      const {
        apiFactory: { positionService },
      } = getEnv();

      return positionService.getOpenPositions(tsAccountId, paginateRequest);
    } catch (e) {
      console.error(`Failed getting open positions`, e);

      return {
        results: [],
        total: 0,
      };
    }
  }

  async getAllPositions(
    tsAccountId: string,
    paginateRequest?: PaginationRequest,
  ) {
    try {
      const {
        apiFactory: { positionService },
      } = getEnv();

      return positionService.getAllPositions(tsAccountId, paginateRequest);
    } catch (e) {
      console.error(`Failed getting all positions`, e);

      return {
        results: [],
        total: 0,
      };
    }
  }

  // TODO: we dont use this at all, remove
  async getValidPositionsCount(tsAccountId: string) {
    const {
      apiFactory: { positionService },
    } = getEnv();

    return positionService.getValidPositionsCount(tsAccountId);
  }

  async getTrades(tsAccountId: string, positionId: string) {
    try {
      const {
        apiFactory: { positionService },
      } = getEnv();

      return positionService.getTrades(tsAccountId, positionId);
    } catch (e) {
      console.error(`Failed getting trades`, e);

      return {
        results: [],
        total: 0,
      };
    }
  }

  async getContestOpenPositions(
    tsAccountId: string,
    paginateRequest?: PaginationRequest,
  ) {
    try {
      const {
        apiFactory: { positionService },
      } = getEnv();

      return positionService.getContestOpenPositions(
        tsAccountId,
        paginateRequest,
      );
    } catch (e) {
      console.error(`Failed getting contest open positions`, e);
      throw e;
    }
  }

  async getContestAllPositions(
    tsAccountId: string,
    paginateRequest?: PaginationRequest,
  ) {
    try {
      const {
        apiFactory: { positionService },
      } = getEnv();

      return positionService.getContestAllPositions(
        tsAccountId,
        paginateRequest,
      );
    } catch (e) {
      console.error(`Failed getting all contest positions`, e);
      throw e;
    }
  }

  async getContestClosedPositions(
    accountId: string,
    paginationRequest: PaginationRequest,
  ) {
    try {
      const {
        apiFactory: { positionService },
      } = getEnv();

      return positionService.getContestClosedPositions(
        accountId,
        paginationRequest,
      );
    } catch (e) {
      console.error(`Failed getting contest closed positions`, e);
      throw e;
    }
  }

  async getPosition(tsAccountId: string, positionId: string) {
    try {
      const {
        apiFactory: { positionService },
      } = getEnv();

      return positionService.getPosition(tsAccountId, positionId);
    } catch (e) {
      console.error(`Failed getting position`, e);
      return null;
    }
  }

  async uploadPositionImage(positionId: string, image: string) {
    try {
      const {
        apiFactory: { positionService },
      } = getEnv();
      const res = await positionService.uploadPositionImage(positionId, image);
      return res.url;
    } catch (e) {
      console.error(`Failed uploadPositionImage`, e);
      throw e;
    }
  }
}
